import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import Spinner from './spinner';

export const dialogSizes={xs:"xs",md:"md",sm:"sm",lg:"lg",xl:"xl"}
const CustomDialog = ({open,handleClose,header,text,text1="",confirm,cancel,size="md",msg={required:false,txt:""}}) => {
    const [loading,setLoading]=useState(false);
    const [emptyFiled,setEmptyField]=useState(false)
    const handleConfirm=async()=>{
        if(msg.required&&(!msg.value||msg.value==" ")) return setEmptyField(true)
        setLoading(true)
        await confirm.action();
        setLoading(false);
        setEmptyField(false)
        handleClose()
    }
  return (
    <div>
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth={size}
        >
            <DialogTitle id="alert-dialog-title">
            {header}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
               <Typography color={"#000000"} variant='subtitle2'>{text}</Typography>
               {text1.map((item,i)=><Typography key={i+"cdt1"} variant='body2'>{item}</Typography>)}
            </DialogContentText>
                {msg.required&&msg.onChange&&
                    <Box>
                        <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Required, reason to disble the store "
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={(e)=>msg.onChange(e.target.value)}
                        value={msg.value}
                        required
                    />
                    {emptyFiled&&<Typography variant='body2' color={"red"}>Please fill the text filed </Typography>}

                    </Box>
            }
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose} sx={{
                color:"#000000",
                border:" 1px solid #E5E7EB",
                borderRadius:2
            }} 
                >{cancel.text}</Button>
            <button onClick={handleConfirm} style={{
                backgroundColor:confirm.color,
                color:"white",
                border:" 1px solid #E5E7EB",
                padding:5,
                borderRadius:4,
                cursor:"pointer",
                minWidth:100,
                textAlign:"center"
            }} >
                {loading?<Spinner color={"white"} />:confirm.text}
            </button>
            </DialogActions>
        </Dialog>
    </div>
  )
}

export default CustomDialog